<template>
    <ul class="nav nav-pills" data-bind="template: { name: 'template-menu-tab-group-tabs-li', foreach: menuTabs }">
        <template v-for="(tab, index) in menuTabs" :key="tab">
            <li class="menu-tab-li" v-if="tab.displayMenuTab() === true">
                <a v-if="tab.displayUpgradeIcon === false" data-toggle="tab" :href="'#' + tab.hrefValue" :title="tab.label" :id="tab.hrefValue + '-id'">
                    {{ tab.label }}
                </a>
                <a v-if="tab.displayUpgradeIcon === true"
                    data-toggle="tab" 
                    :href="'#' + tab.hrefValue" 
                    :id="tab.hrefValue + '-id'" 
                    :data-content="tab.upgradeTooltipMessage"
                    data-placement="bottom"
                >
                    {{ tab.label }}
                    <i class="fa fa-chevron-circle-up fa-lg"></i>
                </a>
            </li>
            <MenuTabGroupButtonVue 
                v-if="menuTabs.length === index + 1 && displayButtonBesideTabs === true"
                :buttonFromParent="menuTabGroupButton">
            </MenuTabGroupButtonVue>
        </template>
    </ul>
    <div class="tab-content">
        <div class="tab-pane fade" v-for="tab in menuTabs" :key="tab" :id="tab.hrefValue" :class="tab.customCss">
            <table>
                <MenuContentItem :itemsFromParent="tab.items.value"></MenuContentItem>
            </table>
        </div>
    </div>
</template>

<script>
import { toRef } from 'vue';
import MenuTabGroupButtonVue from './MenuTabGroupButton.vue';

export default {
    props: {
        tabsFromParent: Array,
        displayButtonBesideTabsFromParent: Boolean,
        menuTabGroupButtonFromParent: Object
    },
    setup(props) {
        // const menuTabs = ref(props.tabsFromParent);
        const menuTabs = toRef(props, "tabsFromParent");
        const menuTabGroupButton = toRef(props, "menuTabGroupButtonFromParent");

        return {
            menuTabs,
            menuTabGroupButton,
            displayButtonBesideTabs: props.displayButtonBesideTabsFromParent
        };
    },
    components: {MenuTabGroupButtonVue}
}
</script>

<style lang="scss" scoped>
</style>